import { gameState } from '@js/state';
import { enablePointerEvents, disablePointerEvents } from '@utils/pointer-events-control';

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'StartScene',
    });
  }

  preload() {
    //audio
    this.load.audio('bgMusic', 'assets/G1 & G2 Game Sounds/gameBGSound.mp3');
  }

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    disablePointerEvents();
    this.BG = this.add
      .image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'BG')
      .setScale(0.5);
    this.cycleBlur = this.add.image(870, 430, 'cycleBlur');
    this.title = this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      'title',
    );
    this.play = this.add.image(640, 500, 'play').setInteractive({ cursor: 'pointer' });
    gameState.bgMusic = this.sound.add('bgMusic'); //audio

    this.play.on(
      'pointerover',
      function (pointer) {
        this.play.setTexture('playBlack');
      },
      this,
    );

    this.play.on(
      'pointerout',
      function (pointer) {
        this.play.setTexture('play');
      },
      this,
    );

    this.play.on(
      'pointerdown',
      function (pointer) {
        enablePointerEvents();
        gameState.bgMusic.setLoop(true).setVolume(0.025).play(); //audio
        this.play.setVisible(false);
        this.scene.start('GetCoinScene');
        /* fullscreen disabled */
      },
      this,
    );
  }
  update() {}
}
